/**
 * RoomDetailsUI - Pure UI component for displaying room details and product list.
 * @param {Object} props
 * @param {Object} props.roomData - Room details (title, description, image, etc.)
 * @param {Array} props.skuList - Array of SKU data objects
 * @param {Function} props.handleNotifyMe - Handler for notify me action
 * @param {Function} props.handleAddToCart - Handler for add to cart action
 * @param {Function} props.handleChange - Handler for quantity change
 * @param {boolean} props.inventoryHydrated - Whether inventory has been hydrated on the client
 * @returns {JSX.Element}
 */
import React from "react"
import RoomProductTileUI from "@/components/ShopTheRoomDetails/ui/RoomProductTileUI"
import RoomSceneImageUI from "@/components/ShopTheRoomDetails/ui/RoomSceneImageUI"

const RoomDetailsUI = ({
  roomData = {},
  skuList = [],
  handleNotifyMe = () => {},
  handleAddToCart = () => {},
  handleChange = () => {},
  inventoryHydrated = false,
  i18n = {},
  presetConfig = {},
  swatchUrl = "",
  skuPrepend = "",
}) => {
  const { roomImageUrl, roomTitle, roomDescription } = roomData || {}
  return (
    <div className="shop-the-room-inspiration">
      <RoomSceneImageUI
        imageUrl={roomImageUrl}
        presetConfig={presetConfig}
        swatchUrl={swatchUrl}
      />
      <div className="shop-the-room-inspiration__right-side">
        <div className="shop-the-room-inspiration__title">{roomTitle}</div>
        <div className="shop-the-room-inspiration__decs">{roomDescription}</div>
        <div className="shop-the-room-inspiration__total">
          {skuList?.length} {i18n.productsLabel}
        </div>
        <div className="shop-the-room-inspiration__Product-list">
          {skuList?.map((sku, i) => (
            <React.Fragment key={i}>
              <RoomProductTileUI
                sku={sku}
                handleNotifyMe={handleNotifyMe}
                handleAddToCart={handleAddToCart}
                handleChange={handleChange}
                inventoryHydrated={inventoryHydrated}
                i18n={i18n}
                presetConfig={presetConfig}
                swatchUrl={swatchUrl}
                skuPrepend={skuPrepend}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RoomDetailsUI
